module.exports = __webpack_public_path__ + "img/booongo.cff0351b.svg";